import clsx from 'clsx';
import { HubertButton } from 'components/HubertUI/HubertButton';
import HubertTooltip from 'components/HubertUI/HubertTooltip';
import { Clipboard } from 'lucide-react';
import { Link } from 'react-router';
import { toast } from 'sonner';

type Props = {
  id: string;
  url?: string;
  showCopyButton: boolean;
  readOnly?: boolean;
  className?: string;
};

const CopyableID = ({ id, url, showCopyButton = true, readOnly = false, className }: Props) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(id);
    toast.info(`Copied to clipboard: ${id}`);
  };

  if (readOnly) {
    return (
      <HubertTooltip contentProps={{ content: id }}>
        <div onClick={handleCopy}>
          <span className={clsx('flex-1 cursor-pointer truncate text-xs font-[200]', className)}>{id}</span>
        </div>
      </HubertTooltip>
    );
  }

  return (
    <div className={clsx('flex flex-row justify-between gap-1', className)}>
      <Link
        to={url ?? `/questions?search=${id}`}
        className={clsx('flex-1 truncate text-xs font-[200] hover:underline', className)}
        title={id}
        target="_blank"
      >
        {id}
      </Link>

      {showCopyButton ? (
        <HubertButton
          onClick={handleCopy}
          variant={'secondary'}
          size={'xs'}
          title="Copy ID"
          icon={<Clipboard className="h-5 w-5" aria-hidden="true" />}
        />
      ) : null}
    </div>
  );
};

export default CopyableID;
